import styled from 'styled-components';
import SCREENS from '@constants/screens';
var Wrapper = styled.div.withConfig({
    displayName: "wrapperstyled__Wrapper",
    componentId: "sc-3k0nyq-0"
})(["margin:0 auto;max-width:64.75rem;width:100%;padding:0 1rem;@media only screen and (min-width:", "){max-width:100%;}@media only screen and (min-width:", "){max-width:540px;}@media only screen and (min-width:", "){max-width:720px;}@media only screen and (min-width:", "){max-width:960px;}@media only screen and (min-width:", "){max-width:1140px;}@media only screen and (min-width:", "){max-width:1320px;}"], SCREENS.xs, SCREENS.sm, SCREENS.md, SCREENS.lg, SCREENS.xl, SCREENS.xxl);
export default Wrapper;
